// A deer, modelled facing +X: four slim legs, a long body, a raised neck and
// head, and a pair of small antlers. Ported 1:1 from age-of-mcp's classic
// deer.ts, restoring its original leg loop + body/neck/head/antler composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.078, 0.04], [0.078, -0.04], [-0.078, 0.04], [-0.078, -0.04]]) {
    parts.push({
      geometry: new THREE.CylinderGeometry(0.0095, 0.0072, 0.18, 4),
      color: "#6b4a2c", position: [x!, 0.09, z!],
    });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.072, 0),
      color: "#8a5e36", position: [0, 0.18, 0], scale: [1.6, 1, 0.9] },
    { geometry: new THREE.CylinderGeometry(0.018, 0.027, 0.115, 5),
      color: "#8a5e36", position: [0.108, 0.223, 0], rotation: [0, 0, -0.7] },
    { geometry: new THREE.IcosahedronGeometry(0.036, 0),
      color: "#a47546", position: [0.158, 0.266, 0] },
    { geometry: new THREE.CylinderGeometry(0.0045, 0.0045, 0.062, 3),
      color: "#d8c8a8", position: [0.165, 0.31, 0.018], rotation: [0, 0, 0.4] },
    { geometry: new THREE.CylinderGeometry(0.0045, 0.0045, 0.062, 3),
      color: "#d8c8a8", position: [0.165, 0.31, -0.018], rotation: [0, 0, 0.4] },
  );
  return parts;
}

export const deer = defineModel({
  id: "deer",
  batchId: "standard",
  name: "Deer",
  tags: ["creature","deer","low-poly","age-of-mcp","classic"],
  summary: "Low-poly deer.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.15,
  parts: () => partsFor(),
  animations: [],
});
